import { Workflow } from '../types';

/**
 * Comparator for the client-defined workflow display order: `order` ascending, with missing/undefined
 * order values sorted last, and workflow name as a stable tiebreak. Shared by the Workflows admin page
 * and the user-form "Approval Workflow" dropdown so both render in the same, client-confirmed sequence.
 */
export function byWorkflowOrder(
  a: Pick<Workflow, 'order' | 'name'>,
  b: Pick<Workflow, 'order' | 'name'>
): number {
  const aOrder = a.order ?? Number.POSITIVE_INFINITY;
  const bOrder = b.order ?? Number.POSITIVE_INFINITY;
  if (aOrder !== bOrder) {
    return aOrder - bOrder;
  }
  return a.name.localeCompare(b.name);
}
